import script from "./AdminEmpDelete.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminEmpDelete.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__